import React, { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import { Switch, Layer, Button, NoData } from 'components'
import styles from 'views/setting/index.module.css'
import AgreeLayer from 'views/setting/AgreeLayer'
import Lib from 'library'
import { showAlarmLayerState } from 'views/setting/states'
import { useRecoilState } from 'recoil'

const AlarmSetting = () => {

	const [showAlarmLayer, setShowAlarmLayer] = useRecoilState(showAlarmLayerState)

	const App = useApp()

	const [eventNotiYn, setEventNotiYn] = useState() // 이벤트마케팅 알림
	const [dailyRprtNotiYn, setDailyRprtNotiYn] = useState() // 오늘의 리포트 알림
	const [dataLinkNotiYn, setDataLinkNotiYn] = useState() // 데이터 연결 정보 알림
	const [paySchdlNotiYn, setPaySchdlNotiYn] = useState() // 납입 예정 알림
	const [crdtChgNotiYn, setCrdtChgNotiYn] = useState() // 신용 정보 변동 알림
	const [terms, setTerms] = useState() // 약관
	const [eventNotiAgreeDe, setEventNotiAgreeDe] = useState() // 마케팅 정보 수신동의 날짜
	const [eventNotiAgreeDeUpd, setEventNotiAgreeDeUpd] = useState() // 마케팅 정보 수신동의 날짜(업데이트)
	const [showLayer, setShowLayer] = useState(false)

	const SetEvent = (t) => { // 이벤트마케팅 저장
		setEventNotiYn(t)
		App.toast(`이벤트 • 마케팅정보 수신여부가 ${new Date().getFullYear()}년 ${new Date().getMonth() + 1}월 ${new Date().getDate()}일 기준 ${t === true ? "동의" : "철회"}되었습니다.`)
	}

	const SetAsset = (t) => { // 오늘의 리포트 저장
		setDailyRprtNotiYn(t)
	}

	const SetExpense = (t) => { // 데이터 연결 정보 저장
		setDataLinkNotiYn(t)
	}

	const SetCredit = (t) => { // 납입 예정 정보 저장
		setPaySchdlNotiYn(t)
	}

	const SetNewInvoiceTime = (t) => { // 신용 정보 변동 저장
		setCrdtChgNotiYn(t)
	}

	// 알림 값 on off 데이터 업데이트
	const setAlarmConfig = () => {
		Lib.post(`/api/setting/noti/config/upd`, {
			crdtChgNotiYn: crdtChgNotiYn === true ? "Y" : "N",
			paySchdlNotiYn: paySchdlNotiYn === true ? "Y" : "N",
			eventNotiYn: eventNotiYn === true ? "Y" : "N",
			dailyRprtNotiYn: dailyRprtNotiYn === true ? "Y" : "N",
			dataLinkNotiYn: dataLinkNotiYn === true ? "Y" : "N",
		})
	}

	//알림 데이터 가져오기
	const getData = () => {
		Lib.post(`/api/setting/noti/config`, data => {
			setCrdtChgNotiYn(data.crdtChgNotiYn === "Y" ? true : false)
			setPaySchdlNotiYn(data.paySchdlNotiYn === "Y" ? true : false)
			setEventNotiYn(data.eventNotiYn === "Y" ? true : false)
			setDailyRprtNotiYn(data.dailyRprtNotiYn === "Y" ? true : false)
			setDataLinkNotiYn(data.dataLinkNotiYn === "Y" ? true : false)
			setTerms(data.eventNotiTerms)
			setEventNotiAgreeDe(data.eventNotiAgreeDe)
		})
	}

	useEffect(() => {
		if (typeof dataLinkNotiYn !== "undefined" && typeof dailyRprtNotiYn !== "undefined" && typeof paySchdlNotiYn !== "undefined" && typeof crdtChgNotiYn !== "undefined" && typeof eventNotiYn !== "undefined") {
			setAlarmConfig()
		}
	}, [paySchdlNotiYn, crdtChgNotiYn, eventNotiYn, dailyRprtNotiYn, dataLinkNotiYn])

	//이벤트 혜택 알림 on/off 에 따른 수신동의 날짜 업데이트
	useEffect(() => {
		const today = Lib.dateFormat(new Date(), "-")
		setEventNotiAgreeDeUpd(today)

		Lib.post(`/api/setting/noti/config`, data => {
			setEventNotiAgreeDe(data.eventNotiAgreeDe)
		}, {
			eventNotiAgreeDe: eventNotiAgreeDeUpd
		})
	}, [eventNotiYn])

	useEffect(() => {
		if (showAlarmLayer === true) {
			getData()
		}
	}, [showAlarmLayer])

	return (
		<Layer show={showAlarmLayer} closeLayer={() => setShowAlarmLayer(false)}>
			<div className="page">
				<div className="shadow">
					<div className="padding">
						<div className={styles.title}>알림 설정</div>
						<ul className={`${styles["link-menu"]} mt_40`}>
							<li>
								<div className="flex-justify_between align_center">
									<p>이벤트 ・ 혜택 알림</p>
									<Switch on={eventNotiYn} onToggle={SetEvent} offText="OFF">ON</Switch>
								</div>
							</li>
							<li>
								<div className="flex-justify_between align_center" onClick={() => setShowLayer(true)}>
									<p>마케팅 정보 수신동의</p>
									{
										eventNotiYn ?
											<p className={styles.agree}>동의 ({eventNotiAgreeDe})<i className="icon icon_arrow_sm right ml_5" /></p>
											:
											<p className={styles.agree}>미동의 ({eventNotiAgreeDe})<i className="icon icon_arrow_sm right ml_5" /></p>
									}
								</div>
							</li>
						</ul>
					</div>
				</div>
				<div>
					<div className="padding">
						<ul className={styles["link-menu"]}>
							<li>
								<div className="flex-justify_between align_center">
									<p>오늘의 리포트 알림</p>
									<Switch on={dailyRprtNotiYn} onToggle={SetAsset} offText="OFF">ON</Switch>
								</div>
								<span>데일리 리포트 전송 알림</span>
							</li>
						</ul>
					</div>
				</div>
				{/* <div className="padding">
					<ul className={styles["link-menu"]}>
						<li>
							<div className="flex-justify_between align_center">
								<p>데이터 연결 정보 알림</p>
								<Switch on={dataLinkNotiYn} onToggle={SetExpense} offText="OFF">ON</Switch>
							</div>
							<span>전송요구 만료 예정, 데이터 활용 내역 알림</span>
						</li>
						<li>
							<div className="flex-justify_between align_center">
								<p>납입 예정 알림</p>
								<Switch on={paySchdlNotiYn} onToggle={SetCredit} offText="OFF">ON</Switch>
							</div>
							<span>결제, 이자/대금 납입 및 자동충전 예정 알림</span>
						</li>
						<li>
							<div className="flex-justify_between align_center">
								<p>신용 정보 변동 알림</p>
								<Switch on={crdtChgNotiYn} onToggle={SetNewInvoiceTime} offText="OFF">ON</Switch>
							</div>
							<span>신용점수, 변동내역, 조회내역 알림</span>
						</li>
					</ul>
				</div> */}
				<AgreeLayerOpen show={showLayer} closeLayer={() => setShowLayer(false)} terms={terms} />
			</div>
		</Layer>
	)
}

//마케팅 정보 수신동의 레이어 
const AgreeLayerOpen = ({ show, closeLayer, terms }) => {
	return (
		<Layer show={show} closeLayer={closeLayer}>
			{terms ?
				<div className="page">
					<div className="flex_1 padding pt_20">
						<h3>{terms.termsNm}</h3>
						<div className={`${styles["agree-terms"]} mt_40`}>
							<p className={"sun-editor-editable " + styles["t-title"]} style={{ lineHeight: 2 }} dangerouslySetInnerHTML={{__html: terms.termsConts}}></p>
						</div>
					</div>
					<div className="flex-shrink_0 padding">
						<Button className="btn btn--big" onClick={() => closeLayer()}>확인</Button>
					</div>
				</div>
				:
				<NoData text="조회중입니다." />
			}
		</Layer>
	)
}

export default AlarmSetting
